export default __webpack_public_path__ + "static/media/dauth.168d1e7d.png";